<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/NetworkIDTs">
              Financial Services
            </b-breadcrumb-item>
            <b-breadcrumb-item active>Computer Leases</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Leases</div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row justify-content-center">
                            <div class="col form-group">
                                <label for="assetNumber">Asset Number</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Asset Number"
                                        v-model="filterOptions.assetNumber"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="serialNumber">Serial Number</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Serial Number"
                                        v-model="filterOptions.serialNumber"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="manufacturer">Manufacturer</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Manufacturer"
                                        v-model="filterOptions.manufacturer"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="modelNumber">Model Number</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Model Number"
                                        v-model="filterOptions.modelNumber"
                                />
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="col-auto form-group">
                                <label for="vendor">Vendor</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Vendor"
                                        v-model="filterOptions.vendor"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label for="lesseeName">Lessee Name</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Lesse Name"
                                        v-model="filterOptions.lesseeName"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <AppCheckBox v-model="filterOptions.onlyShowActiveLeases">
                                    Only Show Active Leases
                                </AppCheckBox>
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <!--<template v-if="filterOptions.assetNumber !== null && filterOptions.assetNumber.trim() !== '' && computerLeases.length === 0 && searchPerformed">
                            <RouterLink :to="{name:'AddComputerAsset',params:{assetNumber:filterOptions.assetNumber}}" class="btn btn-success text-left"
                                        title="Add New Computer Lease">
                                <i class="fa fa-plus"></i>Add Computer Asset
                            </RouterLink>
                        </template>-->
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>
                <div class="d-print-none dropdown mb-3 text-right">
                    <button :disabled="isPerformingAction" aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown" style="width: 100px" type="button">
                        <span>Actions</span>
                    </button>
                    <div class="dropdown-menu">
                        <!--<RouterLink :to="{name: 'AddComputerLease'}" class="btn btn-outline-light dropdown-item text-left"
                                    title="Add New Computer Lease">
                            <i class="fa fa-plus"></i>Add
                        </RouterLink>-->
                        <a @click.prevent="downloadCsvExport()" class="btn btn-outline-light dropdown-item text-left"
                            href="javascript:void(0)" title="Export account list to a CSV">
                            <i class="fa fa-file-excel"></i>Download Active Leases .csv
                        </a>
                    </div>
                </div>
                <BTable :busy="isLoading"
                        :fields="tableFields"
                        :items="computerLeases"
                        :responsive="true"
                        primary-key="id"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                      <div class="row">
                        <div class="col-4 col-lg-3">
                          <a @click="toggleDetails(row)" class="ml-3">
                            <i v-if="!row.item._showDetails" class="fa fa-caret-down fa-lg" />
                            <i v-if="row.item._showDetails" class="fa fa-caret-up fa-lg" />
                          </a>
                        </div>
                        <div class="btn-group col-auto">
                            <router-link
                                    :to="{ name:'EditComputerLease', params:{ id: row.item.id } }"
                                    class="btn btn-sm btn-warning d-print-none"
                                    data-toggle="tooltip"
                                    title="Edit computer lease">
                                <i class="fa fa-pencil-alt"></i>Edit
                            </router-link>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(isSpecialProjectRequest)="row">
                        <span>{{ row.item.isSpecialProjectRequest ? 'Yes' : 'No' }}</span>
                    </template>

                    <template v-slot:row-details="row">
                        <div v-if="row.item.isSpecialProjectRequest" class="card">
                            <div class="card-header">
                                <ul class="card-header-tabs nav nav-tabs">
                                    <li class="nav-item">
                                        <a data-toggle="tab"
                                          role="tab"
                                          class="active nav-link"
                                          :aria-controls="'details-' + row.item.id"
                                          type="button"
                                          :data-target="'#details-' + row.item.id">Details</a>
                                    </li>
                                    <li class="nav-item">
                                        <a data-toggle="tab"
                                          role="tab"
                                          class="nav-link"
                                          :aria-controls="'billing-' + row.item.id"
                                          type="button"
                                          :data-target="'#billing-' + row.item.id">Billing</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content m-3">
                                <div class="tab-pane active" :id="'details-' + row.item.id" role="tabpanel" aria-labelledby="details-tab">
                                    <br />
                                    <b-container>
                                        <div v-for="detailSection in detailFields" :key="detailSection">
                                            <template v-if="detailSection.sectionLabel !== null">
                                                <fieldset class="border p-3 mr-2">
                                                    <legend class="w-auto h5">{{ detailSection.sectionLabel }}</legend>
                                                    <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                                        <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                            <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                            <div class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                                        </b-col>
                                                    </b-row>
                                                </fieldset>
                                            </template>
                                            <template v-else>
                                                <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                                    <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                        <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                        <div class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                                    </b-col>
                                                </b-row>
                                            </template>
                                            <br>
                                        </div>
                                    </b-container>
                                </div>
                                <div class="tab-pane" :id="'billing-' + row.item.id" role="tabpanel" aria-labelledby="billing-tab">
                                    <br />
                                    <BTable :fields="innerTableFields"
                                            :items="row.item.specialProjectRequests"
                                            :responsive="true"
                                            primary-key="accountId"
                                            show-empty
                                            small
                                            table-class="table-align-middle">
                                    </BTable>
                                </div>
                            </div>
                        </div>
                        <b-container v-else>
                            <div v-for="detailSection in detailFields" :key="detailSection">
                                <template v-if="detailSection.sectionLabel !== null">
                                    <fieldset class="border p-3 mr-2">
                                        <legend class="w-auto h5">{{ detailSection.sectionLabel }}</legend>
                                        <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                            <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                <div class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                </template>
                                <template v-else>
                                    <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                        <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                            <div class="font-weight-bold">{{ detailCell.label }}</div>
                                            <div class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                        </b-col>
                                    </b-row>
                                </template>
                                <br>
                            </div>
                        </b-container>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalComputerLeases"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>
                </BTable>
            </div>
        </div>
    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import ComputersService from "@/services/ComputersService";

    export default {
        components: {
            AppTablePagination,
            AppFormCardCollapsable,
            AppCheckBox
        },
        data() {
            return {
                isPerformingAction: false,
                computerLeases: [],
                totalComputerLeases: 0,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    returnAll: false,
                    assetNumber: null,
                    serialNumber: null,
                    manufacturer: null,
                    modelNumber: null,
                    description: null,
                    vendor: null,
                    lesseeName: null,
                    onlyShowActiveLeases: true
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:75px'
                    }, 
                    {
                        key: 'assetNumber',
                        label: 'Asset Number'
                    },
                    {
                        key: 'serialNumber',
                        label: 'Serial Number'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                    },
                    {
                        key: 'leasePurchaseAccountNumber',
                        label: 'Billing Account',
                    },
                    {
                        key: 'isSpecialProjectRequest',
                        label: 'Billed to Different Account(s)',
                    }
                ],
                innerTableFields: [
                    {
                        key: 'accountNumber',
                        label: 'SL-SA'
                    },
                    {
                        key: 'fiscalPeriod',
                        label: 'Fiscal Period'
                    },
                    {
                        key: 'percentageSplit',
                        label: 'Percentage Split'
                    }
                ],
                detailFields: [
                    {
                        sectionLabel: null,
                        sectionDetails: [
                            [
                                {
                                    key: "custodianPersonName",
                                    label: "Custodian"
                                }
                            ]
                        ]
                    },
                    {
                        sectionLabel: "Asset",
                        sectionDetails: [
                            [
                                {
                                    key: "manufacturer",
                                    label: "Manufacturer"
                                },
                                {
                                    key: "modelNumber",
                                    label: "Model Number"
                                }
                            ],
                            [
                                {
                                    key: "vendor",
                                    label: "Vendor"
                                },
                                {
                                    key: "warrantyPeriod",
                                    label: "Warranty Period"
                                }
                            ]
                        ]
                    },
                    {
                        sectionLabel: "Lease",
                        sectionDetails: [
                            [
                                {
                                    key: "lesseePersonName",
                                    label: "Lessee",
                                },
                                {
                                    key: "lesseeOrganization",
                                    label: "Lessee Current Program Code"
                                }
                            ],
                            [
                                {
                                    key: "leaseRate",
                                    label: "Lease Rate"
                                },
                                {
                                    key: "leasePeriod",
                                    label: "Lease Period"
                                }
                            ],
                            [
                                {
                                    key: "createdByPersonName",
                                    label: "Added By"
                                },
                                {
                                    key: "lastModifiedByPersonName",
                                    label: "Last Edited By"
                                }
                            ],
                            [
                                {
                                    key: "createdDate",
                                    label: "Added Date"
                                },
                                {
                                    key: "lastModifiedDate",
                                    label: "Last Edited Date"
                                }
                            ]
                        ]
                    }
                ],
                searchPerformed: false
            }
        },
        methods: {
            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
                this.searchPerformed = true
            },

            loadData() {
                const vm = this;
                vm.isLoading = true;

                ComputersService.getComputerLeases(vm.filterOptions)
                  .then(response => {
                    vm.computerLeases = response.data.map(obj => ({ ...obj, 
                                                                    leasePeriod: obj.leaseStartDate === null || obj.leaseEndDate === null 
                                                                                    ? null
                                                                                    : (new Date(obj.leaseStartDate).toLocaleDateString()) + ' - ' + (new Date(obj.leaseEndDate).toLocaleDateString()),
                                                                    warrantyPeriod: obj.warrantyStartDate === null || obj.warrantyEndDate === null
                                                                                        ? null
                                                                                        : (new Date(obj.warrantyStartDate).toLocaleDateString()) + ' - ' + (new Date(obj.warrantyEndDate).toLocaleDateString()),
                                                                    createdDate: new Date(obj.createdDate).toLocaleDateString(),
                                                                    lastModifiedDate: new Date(obj.lastModifiedDate).toLocaleDateString(),
                                                                    specialProjectRequests: obj.specialProjectRequests.map(s => ({ ...s, fiscalPeriod: s.fiscalPeriodStartDate === null || s.fiscalPeriodEndDate === null 
                                                                                                ? null
                                                                                                : (new Date(s.fiscalPeriodStartDate).toLocaleDateString()) + ' - ' + (new Date(s.fiscalPeriodEndDate).toLocaleDateString()) })),
                                                                    _showDetails: false }));
                    vm.totalComputerLeases = response.totalCount;
                  })
                  .catch(() => {
                    vm.redirectToError()
                  })
                  .finally(() => {
                    vm.isLoading = false;
                  })
            },

            toggleDetails (row) {
              if (!row.item._showDetails) {
                row.item._showDetails = true;
              } else {
                row.item._showDetails = false;
              }
            },

            /**
             * @description Downloads the computer leases CSV export to the user's browser
             */
            downloadCsvExport() {
                this.isPerformingAction = true;
                const vm = this;

                ComputersService.getExcelExport()
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    })
                    .finally(() => {
                        this.isPerformingAction = false
                    });
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
